import type React from "react"

import {cn} from "@/lib/cn"

/**
 * A native radio, not a Radix one -- same reasoning as `Checkbox` in
 * `input.tsx`: every form in the game flows is a server action, so the
 * inputs have to submit with the form. A Radix control is a button plus a
 * hidden input driven by client state; a native one posts its value with no
 * JavaScript at all, which also means these forms still work while the page
 * is hydrating. Keep this in sync with `Checkbox` -- they differ only in
 * being round rather than square-cornered.
 */
export const Radio = ({className, ...props}: React.InputHTMLAttributes<HTMLInputElement>) => (
  <input
    type="radio"
    className={cn(
      "size-4 shrink-0 rounded-full border border-secondary-border bg-background/60",
      "accent-[color:var(--color-link)]",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1",
      "disabled:cursor-not-allowed disabled:opacity-50",
      className,
    )}
    {...props}
  />
)
